import { render, staticRenderFns } from "./EdiAccount.vue?vue&type=template&id=57022890"
import script from "./EdiAccount.vue?vue&type=script&lang=js"
export * from "./EdiAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports